// document.addEventListener("DOMContentLoaded", function () {
//   function checkPill() {
//     let pills = document.querySelectorAll(
//       `[data-handle="conditioning-clarifying-acv-rinse"] [data-bss-pl="active"]`
//     );

//     let flag = false;
//     for (let i = 0; i < pills.length; i++) {
//       if (
//         pills[i].textContent.trim().toLowerCase() === "buy now".toLowerCase()
//       ) {
//         pills[i].setAttribute("style", "border-radius: 50px");
//         flag = true;
//         break;
//       }
//     }

//     return flag;
//   }

//   let interval = setInterval(function () {
//     if (checkPill()) {
//       clearInterval(interval);
//     } else {
//       checkPill();
//     }
//   }, 1000); // Check every second
// });
document.addEventListener("DOMContentLoaded", function () {
  function checkPill() {
    let pills = document.querySelectorAll(
      `[data-handle="conditioning-clarifying-acv-rinse"] [data-bss-pl="active"]`
    );

    let flag = false;
    for (let i = 0; i < pills.length; i++) {
      if (
        pills[i].textContent.trim().toLowerCase() === "buy now".toLowerCase()
      ) {
        pills[i].setAttribute("style", "border-radius: 50px");
        flag = true;
        break;
      }
    }

    return flag;
  }

  let interval = setInterval(function () {
    if (checkPill()) {
      clearInterval(interval);
    } else {
      checkPill();
    }
  }, 1000); // Check every second

  var rbItems = document.querySelectorAll(".rb-box-builder .rb-item");
  let rbItemsinterval = setInterval(function () {
    if (rbItems.length > 0) {
      checkRbItems(rbItems);
      clearInterval(rbItemsinterval);
    } else {
      rbItems = document.querySelectorAll(".rb-box-builder .rb-item");
    }
  }, 1000); // Check every second

  function scroller() {
    let element = document.querySelector(
      ".rb-progress-bar-wrapper [role=progressbar]"
    );
    if (element.ariaValueNow == "100") {
      setTimeout(() => {
        document.querySelector(".rb-addon-item").scrollIntoView({
          behavior: "smooth",
        });
      }, 700);
    }
  }

  function checkRbItems(rbItems) {
    if (rbItems) {
      let rbInputs = document.querySelectorAll(
        ".rb-box-builder .rb-item .rb-input"
      );
      let rbBtns = document.querySelectorAll(
        ".rb-box-builder .rb-item .rb-btn-qty"
      );

      rbBtns.forEach(function (btn) {
        btn.addEventListener("click", function () {
          scroller();
        });
      });

      rbInputs.forEach(function (input) {
        input.addEventListener("change", function () {
          scroller();
        });
      });
    }
  }
});
